<template>
    <div class="playhub-account">
        <playhub-account/>
        <illustration-mosaic />
    </div>
</template>
<script>
export default {
  name: 'PlayHubAccount'
}
</script>
<style lang="scss" scoped>
.playhub-account {
  display: flex;
  justify-content: space-between;
  min-height: 100vh;
  background: $login-background;
  & > .illustration-mosaic {
    display: none;
  }

  @media screen and (min-width: 768px) {
    & > .illustration-mosaic {
      display: inline-flex;
    }
  }
}
</style>
